module.exports = __webpack_public_path__ + "img/starry-night.9dbadadb.jpg";